import { render, staticRenderFns } from "./EmployeeBankAccountCreateOrUpdate.vue?vue&type=template&id=5139a04e&"
import script from "./EmployeeBankAccountCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./EmployeeBankAccountCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports